import { AxiosError } from "axios";

export const getErrorMessage = (error: unknown, fallbackMessage: string) => {
  if (
    error instanceof AxiosError &&
    error.response?.data.message &&
    typeof error.response.data.message === "string"
  ) {
    return error.response.data.message;
  } else {
    return fallbackMessage;
  }
};
